/**
 * Created by mauget on 2/21/16.
 */
// XJService.js

import JXON from 'jxon/jxon';
import constants from 'Constants.js';

//==============================================================================
// This is a wrapper for the library code of Mozilla JXON.
//
// - Lou Mauget, February 21, 2016 and August 5, 2016.
//==============================================================================
class XJService {

    constructor() {
        JXON.config({
            valueKey: constants.JXON_VALUE_KEY,
            attrKey: constants.XATTR_PREFIX,
            attrPrefix: constants.XATTR_PREFIX,
            lowerCaseTags: false,
            trueIsEmpty: false,
            autoDate: false,
            ignorePrefixedNodes: false,
            parseValues: false
        });
    }

    // TODO rename to toJs
    toJSON( xmlStr ) {
        const jsonObj = JXON.stringToJs(xmlStr);
        return jsonObj;
    }


    // TODO rename to toXmlStr
    toXML( jsonObj ){
        const xmlStr = JXON.jsToString(jsonObj);
        return xmlStr;
    }


    stringToXmlDoc( xmlStr ) {
        return JXON.stringToXml( xmlStr );
    }

    jsToXml( jsObj ){
        return JXON.jsToXml( jsObj );
    }

    xmlDocToJs( xmlDoc ) {
        return JXON.xmlToJs( xmlDoc );
    }

    xmlToString( xmlDoc ){
        return JXON.xmlToString( xmlDoc );
    }

}

const xjService = new XJService();
export default xjService;
